"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixEventService = void 0;
const MatrixRoom_1 = require("../models/MatrixRoom");
class MatrixEventService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.cachedPromises = new Map();
    }
    async sync(accessToken, options) {
        return this.withCache('sync', () => this.httpClient.get('/sync', {
            timeout: options ? options.pollingTimeout : undefined,
            since: options ? options.syncToken : undefined
        }, { accessToken }));
    }
    async sendMessage(accessToken, room, content, txnId) {
        return new Promise((resolve, reject) => this.scheduleEvent({
            accessToken,
            room,
            type: 'm.room.message',
            content,
            txnId,
            onSuccess: resolve,
            onError: reject
        }));
    }
    scheduleEvent(event) {
        // TODO: actual scheduling
        this.sendEvent(event);
    }
    async sendEvent(scheduledEvent) {
        const { room, type, txnId, content, accessToken } = scheduledEvent;
        if (room.status !== MatrixRoom_1.MatrixRoomStatus.JOINED && room.status !== MatrixRoom_1.MatrixRoomStatus.UNKNOWN) {
            return Promise.reject(`User is not a member of room ${room.id}.`);
        }
        try {
            const response = await this.httpClient.put(`/rooms/${room.id}/send/${type}/${txnId}`, content, { accessToken });
            scheduledEvent.onSuccess(response);
        }
        catch (error) {
            scheduledEvent.onError(error);
        }
    }
    withCache(key, promiseProvider) {
        let promise = this.cachedPromises.get(key);
        if (!promise) {
            promise = promiseProvider().finally(() => {
                this.cachedPromises.delete(key);
            });
            this.cachedPromises.set(key, promise);
        }
        return promise;
    }
}
exports.MatrixEventService = MatrixEventService;
//# sourceMappingURL=MatrixEventService.js.map